import { render } from "./emp_compensation.vue?vue&type=template&id=41d678b8&scoped=true"
import script from "./emp_compensation.vue?vue&type=script&lang=js"
export * from "./emp_compensation.vue?vue&type=script&lang=js"

import "./emp_compensation.vue?vue&type=style&index=0&id=41d678b8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d678b8"]])

export default __exports__